function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32 64c17.636 0 31.94-14.267 32-31.89v-.22C63.94 14.267 49.636 0 32 0 14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32z",
  fill: "#FFF6D9"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32 64c17.636 0 31.94-14.267 32-31.89v-.22C63.94 14.267 49.636 0 32 0 14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#search-avatar_svg__a)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M56.408 65.66c0 13.54-10.939 24.517-24.432 24.517-13.494 0-24.433-10.977-24.433-24.517s10.939-24.517 24.433-24.517c13.493 0 24.432 10.977 24.432 24.517z",
  fill: "#002F34"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.63 28.57c0 10.39-8.316 18.814-18.572 18.814-10.257 0-18.572-8.423-18.572-18.813 0-10.39 8.315-18.813 18.572-18.813 10.256 0 18.571 8.422 18.571 18.813z",
  fill: "#FFCE32"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.095 30.384a2.09 2.09 0 01-2.087 2.095 2.09 2.09 0 01-2.087-2.095 2.09 2.09 0 012.087-2.094c1.153 0 2.087.938 2.087 2.095zM15.007 25.05c7.116 1.866 14.366-1.954 17.064-8.665 1.629 4.91 6.21 8.447 11.606 8.447 2.25 0 4.357-.614 6.169-1.687-2.3-7.745-9.393-13.388-17.788-13.388-8.95 0-16.42 6.412-18.18 14.947.368.13.745.245 1.129.346z",
  fill: "#002F34"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.465 7.434c0 4.105-3.316 7.433-7.408 7.433-4.09 0-7.408-3.328-7.408-7.433C24.65 3.328 27.966 0 32.057 0c4.092 0 7.408 3.328 7.408 7.434z",
  fill: "#002F34"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M50.207 57.504l1.348-3.197.295-.7-4.756-11.79-5.525 2.243 4.756 11.79 1.621.691 2.261.963z",
  fill: "#D2B982"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.748 27.324c2.776 6.803-.534 14.551-7.393 17.305-6.858 2.754-14.67-.53-17.445-7.333-2.776-6.803.533-14.551 7.392-17.305 6.859-2.754 14.67.53 17.446 7.333z",
  fill: "#D2B982"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.097 24.439c4.376 3.691 4.908 10.203 1.186 14.544-3.72 4.342-10.285 4.869-14.662 1.177a10.26 10.26 0 01-1.186-14.544c3.721-4.341 10.285-4.868 14.662-1.177z",
  fill: "#FFEDB2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.742 32.291a4.474 4.474 0 11-8.949 0 4.474 4.474 0 018.949 0z",
  fill: "#002F34"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.485 55.844c0-3.675 2.969-6.654 6.63-6.654 3.663 0 6.63 2.98 6.63 6.654s-2.967 6.653-6.63 6.653c-3.661 0-6.63-2.979-6.63-6.653z",
  fill: "#FFCE32"
})));

const SvgSearchAvatar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 64,
  height: 64,
  fill: "none"
}, props), _ref, /*#__PURE__*/React.createElement("mask", {
  id: "search-avatar_svg__a",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 64,
  height: 64
}, _ref2), _ref3);

export default SvgSearchAvatar;